import React, { useState } from "react";
import style from "./style.module.scss";
import ButtonIcon from "../../../../../../../components/ButtonIcon/ButtonIcon";
import CaretRight from "../../../../../../../assets/svg/icons/common/CaretRight";
import ChildTable from "./ChildTable";
import { dateFormatter, formatCurrency } from "../../../../../../../../components/helper/helper";

function Row({ data }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <tr className={style.table_row}>
        <td className={style.table_cell}>
          <ButtonIcon
            bgColor={"#FF"}
            onClick={() => {
              setIsOpen(!isOpen);
            }}
            className={`${isOpen ? style.collapse_button : ""}`}
          >
            <CaretRight />
          </ButtonIcon>
        </td>
        <td className={style.table_cell}>{data?.card_number}</td>
        <td className={style.table_cell}>{data?.authorization_number}</td>
        <td className={style.table_cell}>{data?.chargeback_amount ? formatCurrency(data?.chargeback_amount) : '-'}</td>
        <td className={style.table_cell}>{dateFormatter(data?.chargeback_date)}</td>
        <td className={style.table_cell}>{dateFormatter(data?.last_act_date)}</td>
        <td className={style.table_cell}>{data?.days_old}</td>
        <td className={style.table_cell}>{data?.days_to_rebut}</td>
        <td className={style.table_cell}>{data?.chargeback_description}</td>
        <td className={style.table_cell}>{data?.represent_date ? dateFormatter(data?.represent_date) : "-"}</td>
      </tr>
      {isOpen && <ChildTable data={data?.details} />}
    </>
  );
}

export default Row;
